import React from 'react';
import RestoreIcon from '@mui/icons-material/Restore';
import {
  Box,
  FormControl,
  FormHelperText,
  FormLabel,
  IconButton,
  Typography,
} from '@mui/material';


const HEX_COLOR = /^#[0-9A-Fa-f]{6}$/;

const SalonEffectiveColorControl = ({
  label,
  value,
  inheritedColor,
  error = '',
  onChange,
  resetLabel,
  disabled = false,
  inputRef,
  hideVisibleLabel = false,
}) => {
  const hasExplicitColor = HEX_COLOR.test(value || '');
  const fallbackColor = HEX_COLOR.test(inheritedColor || '')
    ? inheritedColor
    : '#000000';
  const effectiveColor = (hasExplicitColor ? value : fallbackColor).toUpperCase();

  return (
    <FormControl error={Boolean(error)} disabled={disabled} sx={{ minWidth: 0 }}>
      {!hideVisibleLabel && (
        <FormLabel sx={{ mb: 0.5, fontSize: '0.75rem', fontWeight: 700 }}>
          {label}
        </FormLabel>
      )}
      <Box
        sx={{
          minHeight: 40,
          display: 'grid',
          gridTemplateColumns: hasExplicitColor ? '32px minmax(72px, 1fr) 36px' : '32px minmax(72px, 1fr)',
          alignItems: 'center',
          gap: 0.75,
          px: 0.75,
          border: '1px solid',
          borderColor: error ? 'error.main' : 'divider',
          borderRadius: 1,
          bgcolor: 'background.paper',
        }}
      >
        <Box
          component="input"
          type="color"
          aria-label={label}
          value={effectiveColor}
          onChange={(event) => onChange(event.target.value.toUpperCase())}
          ref={inputRef}
          disabled={disabled}
          sx={{
            width: 32,
            height: 30,
            p: 0,
            border: 0,
            borderRadius: 0.75,
            bgcolor: 'transparent',
            cursor: disabled ? 'default' : 'pointer',
          }}
        />
        <Typography variant="body2" sx={{ fontFamily: 'monospace', whiteSpace: 'nowrap' }}>
          {effectiveColor}
        </Typography>
        {hasExplicitColor && (
          <IconButton
            type="button"
            size="small"
            aria-label={`${resetLabel} — ${label}`}
            onClick={() => onChange('inherit')}
            disabled={disabled}
          >
            <RestoreIcon fontSize="small" />
          </IconButton>
        )}
      </Box>
      {error && <FormHelperText role="alert">{error}</FormHelperText>}
    </FormControl>
  );
};

export default SalonEffectiveColorControl;
